import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import headerImage from "../../../../assets/img/longarrow.jpg";

const AddBankDetailsDrawer = ({ isOpen, onClose, onAddBank }) => {
  const [formData, setFormData] = useState({
    bank_name: "",
    branch_name: "",
    account_number: "",
    swift_code: "",
    branch_code: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    onAddBank(formData);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add Bank Details</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Bank Name"
            name="bank_name"
            value={formData.bank_name}
            onChange={handleChange}
            placeholder="Enter bank name"
          />
          <ReusableInput
            label="Branch Name"
            name="branch_name"
            value={formData.branch_name}
            onChange={handleChange}
            placeholder="Enter branch name"
          />
          <ReusableInput
            label="Account Number"
            name="account_number"
            value={formData.account_number}
            onChange={handleChange}
            placeholder="Enter account number"
          />
          <ReusableInput
            label="SWIFT Code"
            name="swift_code"
            value={formData.swift_code}
            onChange={handleChange}
            placeholder="Enter SWIFT code"
          />
          <ReusableInput
            label="Branch Code"
            name="branch_code"
            value={formData.branch_code}
            onChange={handleChange}
            placeholder="Enter branch code"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} fontSize="15px" width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddBankDetailsDrawer;
